export enum Language {
  CS = 'cs',
  EN = 'en',
}
